import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EcologicalZoneCard = ({ zone, onClick }) => {
  const getStatusColor = (status) => {
    const colors = {
      'Excellent': 'bg-success text-success-foreground',
      'Good': 'bg-info text-info-foreground',
      'Fair': 'bg-warning text-warning-foreground',
      'At Risk': 'bg-error text-error-foreground'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-[var(--color-card)] rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic group border border-[var(--color-border)]">
      <div className="relative h-64 overflow-hidden">
        <Image
          src={zone?.image}
          alt={zone?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 animation-organic"
        />
        <div className={`absolute top-3 right-3 px-3 py-1.5 rounded-full text-xs font-medium ${getStatusColor(zone?.conservationStatus)}`}>
          {zone?.conservationStatus}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
          <h3 className="text-xl font-bold text-white mb-1">{zone?.name}</h3>
          <p className="text-sm text-white/90">{zone?.location}</p>
        </div>
      </div>
      <div className="p-5">
        <p className="text-sm text-[var(--color-muted-foreground)] mb-4 line-clamp-2">{zone?.description}</p>
        
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2">
            <Icon name="MapPin" size={16} className="text-primary" />
            <div>
              <p className="text-xs text-[var(--color-muted-foreground)]">Area</p>
              <p className="text-sm font-medium text-[var(--color-foreground)]">{zone?.area}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Users" size={16} className="text-secondary" />
            <div>
              <p className="text-xs text-[var(--color-muted-foreground)]">Species</p>
              <p className="text-sm font-medium text-[var(--color-foreground)]">{zone?.speciesCount}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-4">
          {zone?.keyFeatures?.slice(0, 3)?.map((feature, index) => (
            <span key={index} className="px-2 py-1 bg-[var(--color-muted)]/50 text-[var(--color-muted-foreground)] text-xs rounded-full">
              {feature}
            </span>
          ))}
        </div>

        <Button 
          variant="outline" 
          fullWidth 
          onClick={onClick}
          iconName="Eye"
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default EcologicalZoneCard;